"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactflow_1 = require("reactflow");
var IWorkflow_1 = require("../../../../../../interfaces/IWorkflow");
var mdi_chevron_right_circle_1 = require("../../../../../../components/icons/mdi-chevron-right-circle");
var mdi_circle_outline_1 = require("../../../../../../components/icons/mdi-circle-outline");
var mdi_chevron_right_circle_outline_1 = require("../../../../../../components/icons/mdi-chevron-right-circle-outline");
var mdi_circle_1 = require("../../../../../../components/icons/mdi-circle");
var NodePinComponent = function (_a) {
    var _b;
    var _c;
    var pin = _a.pin, position = _a.position, _d = _a.isConnected, isConnected = _d === void 0 ? false : _d, _e = _a.showLabel, showLabel = _e === void 0 ? true : _e, onPinClick = _a.onPinClick;
    var isInput = pin.direction === IWorkflow_1.PinDirection.INPUT;
    var isExecution = pin.type === IWorkflow_1.PinType.EXECUTION;
    var isData = pin.type === IWorkflow_1.PinType.DATA;
    // Pin styling based on type and state
    var getPinClassName = function () {
        var baseClasses = "h-5 w-5 justify-center items-center flex";
        if (isExecution) {
            // Execution pins are triangular/arrow-like - use clip-path for triangle
            return "".concat(baseClasses, " !bg-transparent border-0");
        }
        else if (isData) {
            // Data pins are circular
            baseClasses += " rounded-full";
            if (isConnected) {
                return "".concat(baseClasses, " !bg-blue-500 border-blue-700 shadow-md");
            }
            else {
                return "".concat(baseClasses, " !bg-blue-200 border-blue-400 hover:!bg-blue-300");
            }
        }
        return "".concat(baseClasses, " rounded !bg-gray-300 border-gray-500");
    };
    var getPinIcon = function () {
        // const className = "h-5 w-5 text-secondary pointer-events-none rounded-full bg-white border-s-2 border-borders";
        var className = "h-5 w-5 text-secondary pointer-events-none z-10";
        if (isExecution) {
            if (isConnected) {
                return (0, jsx_runtime_1.jsx)(mdi_chevron_right_circle_1.MdiChevronRightCircle, { className: className });
            }
            return (0, jsx_runtime_1.jsx)(mdi_chevron_right_circle_outline_1.MdiChevronRightCircleOutline, { className: className });
        }
        if (isConnected) {
            return (0, jsx_runtime_1.jsx)(mdi_circle_1.MdiCircle, { className: className });
        }
        return (0, jsx_runtime_1.jsx)(mdi_circle_outline_1.MdiCircleOutline, { className: className });
    };
    var handlePinClick = function (e) {
        e.stopPropagation();
        if (onPinClick) {
            onPinClick(pin);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "relative flex items-center gap-2 min-h-[14px] justify-start ".concat(isInput ? "flex-row" : "flex-row-reverse") }, { children: [(0, jsx_runtime_1.jsxs)(reactflow_1.Handle, __assign({ type: isInput ? "target" : "source", position: position, id: pin.id, className: getPinClassName(), onClick: handlePinClick, title: "".concat(pin.name, " (").concat(pin.type, ")"), style: (_b = {
                        position: "absolute"
                    },
                    _b[isInput ? "left" : "right"] = "-6px",
                    _b.top = "50%",
                    _b.transform = "translateY(-50%)",
                    _b.zIndex = 20,
                    _b) }, { children: [getPinIcon(), (0, jsx_runtime_1.jsx)("div", { className: "absolute w-5 h-5 rounded-full bg-white border-2 border-borders pointer-events-none" })] })), showLabel && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "text-xs text-labelText font-medium select-none ".concat(isInput ? "ml-4 text-start" : "mr-4 text-end"), title: ((_c = pin.metadata) === null || _c === void 0 ? void 0 : _c.description) || pin.name }, { children: !isExecution && pin.name })))] })));
};
exports.default = (0, react_1.memo)(NodePinComponent);
